import s from './styles.module.scss'

export const PhotoGridLoadingSlot = () => (
  <div className={s.slot}>
    <div className={s.spinner} />
  </div>
)
